import { handleGetAvailability, handleSetAvailability } from "../../../../../redux/specialist-slices/auth.slice"
import { Box, Typography, Button, Stack, Skeleton, CircularProgress } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import Slot from "./slot"

const daysOfWeek = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"]
function Availability() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const availabilityData = useRef({})
  const [data, setData] = useState({})
  const { loadings } = useSelector((s) => s.otherSlice)

  // --------------- Handle retrieve availability ---------------
  const handleChange = (data) => {
    availabilityData.current = {
      ...availabilityData.current,
      schedule: {
        ...availabilityData.current.schedule,
        ...data
      }
    }
  }

  // --------------- Handle retrieve availability ---------------
  const retrieveSingle = async () => {
    const { availability } = await dispatch(
      handleGetAvailability()
    ).unwrap() || {}
    if (availability) {
      setData(availability)
      availabilityData.current = availability
    }
  }

  // --------------- Handle update availability ---------------
  const updateSingle = async () => {
    availabilityData.current.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const { success } = await dispatch(
      handleSetAvailability(availabilityData.current)
    ).unwrap()
    if (success)
      navigate("/specialist/profile/availability")
  }

  useEffect(() => {
    retrieveSingle()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Typography sx={{ fontSize: "24px", fontWeight: "600", mb: 3 }}>
        Update chat availability
      </Typography>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Weekly Schedule
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Select days and set your available hours
        </Typography>

        <Stack spacing={2}>
          {loadings?.retrieveSingle ?
            new Array(7).fill().map((_, i) => (
              <Skeleton key={i} sx={{ width: "100%", height: 80, transform: "none" }} />
            )) :
            daysOfWeek.map((element, i) => (
              <Slot
                key={i}
                data={data}
                day={element}
                handleChange={handleChange}
              />
            ))
          }
        </Stack>
      </Box>

      <Button
        size="large"
        sx={{ px: 4 }}
        variant="contained"
        onClick={updateSingle}
        endIcon={
          loadings?.create && (
            <CircularProgress size={22} color="text" thickness={6} />
          )
        }
      >Save
      </Button>
    </>
  )
}

export default Availability